import { createGlobalStyle } from 'styled-components'
require('typeface-open-sans')

export const GlobalStyles = createGlobalStyle`
  :root {
    --content-background-light: #f2f6f8;
    --highlight-blue: #1a5dc8;
    --content-background-dark-blue: #101f73;
    --graphic-accent-blue-1: #0b96d7;
    --graphic-accent-blue-2: #52b9e9;
    --graphic-accent-purple-1: #829fe8;
    --graphic-accent-purple-2: #3771cf;
    --graphic-accent-orange-1: #f29f05;
    --graphic-accent-orange-2: #f58220;

    /* 1rem = 10px */
    font-size: 62.5%;
  }

  html,
  body,
  p,
  ol,
  ul,
  li,
  dl,
  dt,
  dd,
  blockquote,
  figure,
  fieldset,
  legend,
  textarea,
  pre,
  iframe,
  hr,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    padding: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: normal;
  }

  ul {
    list-style: none;
  }

  html {
    box-sizing: border-box;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    overflow-x: hidden;
    font-family: 'Open Sans', Tahoma, sans-serif;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    margin: 0;
    padding: 0;
  }

  button,
  input,
  select,
  textarea {
    margin: 0;
  }

  input {
    background-color: var(--content-background-light);
    color: var(--content-background-dark-blue);
    border: 0;
    padding-left: 16px;

    /* ::placeholder {
      color: var(--content-background-dark-blue);
    } */
  }

  button {
    cursor: pointer;
    border: none;
    padding: 0;
    outline: none;
    overflow: visible;
  }

  a {
    cursor: pointer;
    color: var(--highlight-blue);
  }

  img {
    border-radius: 5px;
  }

  img,
  video {
    height: auto;
    max-width: 100%;
  }

  iframe {
    border: 0;
  }

  .superscript {
    vertical-align: super;
    font-size: 70%;
  }

  .AdvanceArticleHerostyles__HeroTextRegion-sc-1q5bhvy-5.jjAxvo img {
    max-width: 367px;
    margin: 0 0 0 auto;
    order: 2;
  }

  .AdvanceArticleHerostyles__TextColumn-sc-1q5bhvy-3.drmpBo {
    grid-area: 1 / 1 / auto / 3;
    width: 100%;
  }

  .AdvanceArticleHerostyles__CenteredTextColumn-sc-1q5bhvy-6.eBNwun {
    order: 1;
    height: 300px;
    max-width: 63%;
    min-width: 50%;
  }

  .AdvanceArticleHerostyles__CenteredTextColumn-sc-1q5bhvy-6.eBNwun p {
    font-size: 2rem;
  }

  span.AdvanceArticleHerostyles__HeroTitle-sc-1q5bhvy-7.dhSAJP h1 {
    padding-bottom: 10px;
    font-size: 4.8rem;
  }

  @media only screen and (max-width:768px) { 
    .AdvanceArticleHerostyles__HeroTextRegion-sc-1q5bhvy-5.jjAxvo img{
      max-width: unset !important;
      order: unset !important;
    }

    .AdvanceArticleHerostyles__CenteredTextColumn-sc-1q5bhvy-6.eBNwun{
      order: unset !important;
      height: unset !important;
      max-width: unset !important;
      min-width: unset !important;
    }

    span.AdvanceArticleHerostyles__HeroTitle-sc-1q5bhvy-7.dhSAJP h1{
      padding-bottom: unset;
      font-size: 2.8rem;
    }

    .AdvanceArticleHerostyles__CenteredTextColumn-sc-1q5bhvy-6.eBNwun p{
      font-size: unset;
    }

    .AdvanceArticleHerostyles__TextColumn-sc-1q5bhvy-3.drmpBo {
      grid-area: 1 / 1 / auto / 4;
      width: 100%;
    }
  }

  @media only screen and (max-width: 480px) {
    .two-column-layout__main figure{
      display: block;
      margin-top: 32px !important;
      position: relative;
      padding-bottom: 0;
    }

    .AdvanceArticleHerostyles__CenteredTextColumn-sc-1q5bhvy-6.eBNwun {
      height: 185px;
      min-width: unset;
    }
  }
`
